module.exports = __webpack_public_path__ + "media/images/lp_seiho/sec01_img_01-2396a68a678e5dc284fbc9a881621be8.png";